import React from 'react';
import styled, { css } from 'styled-components';

import theme from '../../../../styled-components/dark';

const Wrapper = styled.div``;

type SvgElementType = {
  $isEnded: boolean;
};

const SvgElement = styled.svg<SvgElementType>`
  width: 100%;
  height: 100%;

  ${({ $isEnded }) => {
    if ($isEnded) {
      return css`
        --LineUpFormula1PitStop-fill-color: ${theme.LineUpPitStop.ended.fillColor};
        --LineUpFormula1PitStop-fill-opacity: ${theme.LineUpPitStop.ended.fillOpacity};
      `;
    }
    return css`
      --LineUpFormula1PitStop-fill-color: ${theme.LineUpPitStop.default.fillColor};
      --LineUpFormula1PitStop-fill-opacity: ${theme.LineUpPitStop.default.fillOpacity};
    `;
  }}
`;

const Path = styled.path`
  fill: var(--LineUpFormula1PitStop-fill-color);
  fill-opacity: var(--LineUpFormula1PitStop-fill-opacity);
`;

type LineUpFormula1PitStopSvgAsComponentProps = {
  className?: string;
  isEnded?: boolean;
};

const LineUpFormula1PitStopSvgAsComponent = ({
  className = '',
  isEnded = false,
}: LineUpFormula1PitStopSvgAsComponentProps) => {
  return (
    <Wrapper className={className}>
      <SvgElement $isEnded={isEnded} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.01449 1.64706C1.01449 0.737413 1.74122 0 2.63768 0H8.11594C9.0124 0 9.73913 0.737413 9.73913 1.64706V8.02941H11.1594C11.3835 8.02941 11.5652 8.21377 11.5652 8.44118V10.5C11.5652 10.9548 11.9286 11.3235 12.3768 11.3235C12.825 11.3235 13.1884 10.9548 13.1884 10.5V7.41176H11.5652C11.3411 7.41176 11.1594 7.22741 11.1594 7V4.94118C11.1594 4.71376 11.3411 4.52941 11.5652 4.52941H12.9189L11.7015 3.29412H10.8551C10.631 3.29412 10.4493 3.10976 10.4493 2.88235C10.4493 2.65494 10.631 2.47059 10.8551 2.47059H11.8696C11.9772 2.47059 12.0804 2.51397 12.1565 2.59119L13.8811 4.34119C13.9572 4.41841 14 4.52315 14 4.63235V10.5C14 11.4096 13.2733 12.1471 12.3768 12.1471C11.4803 12.1471 10.7536 11.4096 10.7536 10.5V8.85294H9.73913V12.9706H10.5507C10.6628 12.9706 10.7536 13.0628 10.7536 13.1765V13.7941C10.7536 13.9078 10.6628 14 10.5507 14H0.202898C0.0908406 14 0 13.9078 0 13.7941V13.1765C0 13.0628 0.0908408 12.9706 0.202899 12.9706H1.01449V1.64706ZM13.1884 5.35294H11.971V6.58824H13.1884V5.35294ZM1.82609 1.64706C1.82609 1.19224 2.18945 0.823529 2.63768 0.823529H8.11594C8.56417 0.823529 8.92754 1.19224 8.92754 1.64706V3.70588C8.92754 4.16071 8.56417 4.52941 8.11594 4.52941H2.63768C2.18945 4.52941 1.82609 4.16071 1.82609 3.70588V1.64706Z"
        />
      </SvgElement>
    </Wrapper>
  );
};

export default LineUpFormula1PitStopSvgAsComponent;
